import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tab from "./Tab";
import "./Tabs.css";

const Tabs = ({ tabs, children, defaultTab = 0, rightContent }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const isRouteTabActive = (tab) => {
    if (!tab.to) {
      return false;
    }

    if (typeof tab.isActive === "function") {
      return tab.isActive(location);
    }

    if (tab.exact || tab.to === "/") {
      return location.pathname === tab.to;
    }

    return location.pathname.startsWith(tab.to);
  };

  return (
    <div className="tabs-container">
      <div className="tabs-header-row">
        <div className="tabs">
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              onClick={() => (tab.to ? navigate(tab.to) : handleTabClick(index))}
              isActive={tab.to ? isRouteTabActive(tab) : index === activeTab}
            />
          ))}
        </div>
        {rightContent && (
          <div className="tabs-right">
            {rightContent}
          </div>
        )}
      </div>
      <div className="tab-content">
        {Array.isArray(children) ? children[activeTab] : children}
      </div>
    </div>
  );
};

export default Tabs;
